import React from "react";
//Assets
import logo from "assets/images/logo.png";
const Logo = () => {
    return <img style={{width:"60px"}} src={logo} alt="logo" />;
};
export default Logo;
